import React, { useState, useEffect } from 'react';
import SangatTable from './SangatTable';
import { useHistory } from "react-router-dom";
import AddEditUser from './addEditUserForm';
import { allColumns, taxiReport, returnSangatReport, arrivalReport, babaJiReport, roomReport } from './reportColumnDefs'
import { SUPERUSER_LIST, ROOMS_REPORT } from '../../constants';
import { HerokuURL } from '../../constants';
import { authenticationService } from '../../authenticationService';
import { Alert, AlertTitle, Button, Grid, Paper, Snackbar, ToggleButton, ToggleButtonGroup } from '@mui/material';
import Loader from '../general/loader';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc'
import timezone from 'dayjs-timezone-iana-plugin';

const TableView = {
    ALL: "All",
    ARRIVAL: "Arrival",
    RETURN: "Return",
    TAXI: "Taxi",
    PENDING: "Pending User",
    BABAJI: "Baba Ji",
    ROOMS: "Rooms"

}

const Sangat = (props) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const { Role, currentUser } = props;
    const history = useHistory();

    const isSuperUser = currentUser && SUPERUSER_LIST.includes(currentUser) ? true : false;
    const isRoomSevadar = currentUser && ROOMS_REPORT.includes(currentUser) ? true : false;

    const [users, setUsers] = useState([])
    const [columnDefs, setColumnDefs] = useState(allColumns);
    const [showAddEditDialog, setShowAddEditDialog] = useState(false);
    const [userToEdit, setUserToEdit] = useState(null);
    const [view, setView] = useState(TableView.ALL);
    const [loading, setLoading] = useState(true);
    const [showArrivingWithinThreeDays, setShowArrivingWithinThreeDays] = useState(false);
    const [snack, setSnack] = useState({ message: "", duration: 0, open: false, severity: "success" });
    const [flagLateEntryRow, setFlagLateEntryRow] = useState(false);



    const handleEditUser = (selectedUser) => {
        if (Role !== 'ROLE_USER') {
            setUserToEdit(selectedUser);
            setShowAddEditDialog(true);
        }
    }

    const onSaveSuccessCallBack = (updatedUser) => {
        setSnack({ message: updatedUser.user_firstName + " " + updatedUser.user_middleName + " " + updatedUser.user_lastName + " was successfully saved.", duration: 6000, open: true, severity: "success" });
        const index = users.findIndex(row => row._id === updatedUser._id);
        const usersCopy = [...users];
        if (view === TableView.PENDING) {
            usersCopy.splice(index, 1);
        } else {
            if (index >= 0) {
                usersCopy[index] = updatedUser;
            } else {
                usersCopy.push(updatedUser)
            }
        }
        setUsers(usersCopy);
    }

    const closeSnack = () => {
        setSnack({ ...snack, open: false });
    }
    // TODO
    const onSaveAndAddNewCallBack = (sangat) => {
        setLoading(true);
        let saveUserResponse;
        if (sangat.user_ride_from_airport === "YES") {
            // +utc 5:30 is the India timezone for arrival time where sangat will be landing
            if (Math.abs(dayjs().diff(dayjs(sangat.user_arrivingFlightDate + " " + sangat.user_arrivingFlightTime + "+05:30"), "hour")) <= 48) {
                setShowArrivingWithinThreeDays(true);
            }
        }

        if (userToEdit && userToEdit._id) {
            sangat._id = userToEdit._id;
            //update
            saveUserResponse = fetch(`${HerokuURL}api/user/update`, {
                method: 'PUT',
                headers: {
                    "x-access-token": localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    sangat
                ),
            })
        } else {
            // create new one
            saveUserResponse = fetch(`${HerokuURL}api/user/create`, {
                method: 'POST',
                headers: {
                    "x-access-token": localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    sangat
                ),
            })
        }

        saveUserResponse.then((response) => response.json()).then((data) => {

            // if (data.message && data.message === 'Failed! User is already in System!') {
            //     setSnack({ open: true, severity: "error", durration: 6000, message: "This user is already in the system, and cannot be created again. Please search for them and update the information." })
            //     setLoading(false);
            //     return;
            // }

            onSaveSuccessCallBack(data);

            setUserToEdit({ ...sangat, _id: null, user_firstName: "", user_middleName: "", user_lastName: "", user_gender: "", user_yearOfBirth: null, user_ride_from_airport: "" });
            document.getElementById("startForm").scrollIntoView();
        });

        setLoading(false);

    }



    const onSaveCallBack = (sangat) => {
        setLoading(true);
        if (sangat.user_ride_from_airport === "YES") {
            // +utc 5:30 is the India timezone for arrival time where sangat will be landing
            if (Math.abs(dayjs().diff(dayjs(sangat.user_arrivingFlightDate + " " + sangat.user_arrivingFlightTime + "+05:30"), "hour")) <= 48) {
                setShowArrivingWithinThreeDays(true);
            }
        }
        let saveUserResponse;
        if (view === TableView.PENDING) {
            console.log("In Pending user check");
            saveUserResponse = fetch(`${HerokuURL}api/checkPendingMerge`, {
                method: 'POST',
                headers: {
                    "x-access-token": localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    sangat
                ),
            });

            saveUserResponse.then((response) => response.json()).then((data) => {
                const existingPendingUser = { ...sangat, _id: userToEdit._id }

                if (data.message && data.message === 'User Existing') {

                    const valueToUpdate = { ...sangat, _id: data.id };


                    const pendingRespone = fetch(`${HerokuURL}api/user/update`, {
                        method: 'PUT',
                        headers: {
                            "x-access-token": localStorage.getItem('accessToken'),
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(
                            valueToUpdate
                        ),
                    })
                    pendingRespone.then((response) => {
                        if (response.ok) {

                            const deletedUses = fetch(`${HerokuURL}api/deletePendingUser`, {
                                method: 'DELETE',
                                headers: {
                                    "x-access-token": localStorage.getItem('accessToken'),
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(
                                    existingPendingUser
                                ),
                            })
                            deletedUses.then((anything) => {
                                onSaveSuccessCallBack(existingPendingUser);
                                handleCloseModalCallback();
                            });
                        } else {
                            setSnack({ open: true, severity: "error", durration: 6000, message: "The user could not be saved." });
                        }
                    });
                }
                if (data.message && data.message === 'User not Found') {
                    const pendingRespone = fetch(`${HerokuURL}api/user/create`, {
                        method: 'POST',
                        headers: {
                            "x-access-token": localStorage.getItem('accessToken'),
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(
                            sangat
                        ),
                    })
                    pendingRespone.then((response) => {
                        if (response.ok) {
                            const deletedUses = fetch(`${HerokuURL}api/deletePendingUser`, {
                                method: 'DELETE',
                                headers: {
                                    "x-access-token": localStorage.getItem('accessToken'),
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(
                                    existingPendingUser
                                ),
                            })
                            deletedUses.then((anything) => {
                                onSaveSuccessCallBack(existingPendingUser);
                                handleCloseModalCallback();
                            });
                        } else {
                            setSnack({ open: true, severity: "error", durration: 6000, message: "The user could not be saved." });
                        }
                    });
                }
            });
        } else {
            if (userToEdit && userToEdit._id) {
                sangat._id = userToEdit._id;
                //update
                saveUserResponse = fetch(`${HerokuURL}api/user/update`, {
                    method: 'PUT',
                    headers: {
                        "x-access-token": localStorage.getItem('accessToken'),
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(
                        sangat
                    ),
                })
            } else {
                // create new one
                saveUserResponse = fetch(`${HerokuURL}api/user/create`, {
                    method: 'POST',
                    headers: {
                        "x-access-token": localStorage.getItem('accessToken'),
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(
                        sangat
                    ),
                })
            }

            saveUserResponse.then((response) => response.json()).then((data) => {
                // if (data.message && data.message === 'Failed! User is already in System!') {
                //     setSnack({ open: true, severity: "error", durration: 6000, message: "This user is already in the system, and cannot be created again. Please search for them and update the information." })
                //     setLoading(false);
                //     return;
                // }
                console.log(data);
                onSaveSuccessCallBack(data);
                handleCloseModalCallback();
            });
        }

        setLoading(false);

    }

    const handleTableViewChange = (event, newView) => {
        console.log("VIEW INFO", newView)
        switch (newView) {
            case TableView.ALL:
                setColumnDefs(allColumns);
                setFlagLateEntryRow(false);
                break;
            case TableView.ARRIVAL:
                setColumnDefs(arrivalReport);
                setFlagLateEntryRow(false);
                break;
            case TableView.RETURN:
                setColumnDefs(returnSangatReport);
                setFlagLateEntryRow(false);
                break;
            case TableView.TAXI:
                setColumnDefs(taxiReport);
                setFlagLateEntryRow(true);
                break;
            case TableView.PENDING:
                setColumnDefs(allColumns);
                setFlagLateEntryRow(false);
                break;
            case TableView.BABAJI:
                setColumnDefs(babaJiReport);
                setFlagLateEntryRow(false);
                break;
            case TableView.ROOMS:
                setColumnDefs(roomReport);
                setFlagLateEntryRow(true);
        }
        setView(newView);
    }

    useEffect(() => {
        setLoading(true);
        var url = "api/getUsersWithFlightInfo";
        if (view == TableView.ALL) {
            url = "api/getAllUsers";
        }
        else if (view == TableView.PENDING) {
            url = "api/getPendingUsers";
        } else if (view == TableView.TAXI) {
            url = "api/getUsersThatNeedRide"
        }

        fetch(`${HerokuURL}` + url, { headers: { "x-access-token": localStorage.getItem('accessToken') } }).then(res => res.json()).then(jsonRes => {
            setLoading(false);
            setUsers(jsonRes);
        })
    }, [view]);
    if (users && users.message === "Unauthorized!") {
        authenticationService.logout();
        history.push('/');
        window.location.reload();
    }

    const addNewUser = () => {
        setUserToEdit(null)
        setShowAddEditDialog(true);
    }

    const handleCloseModalCallback = () => {
        setUserToEdit(null);
        setShowAddEditDialog(false);
    }

    return (
        <div>

            <Loader open={loading} />
            {showAddEditDialog && <AddEditUser key={userToEdit} title={userToEdit && userToEdit._id ? "Edit Flight Information" : "Add Flight Information"} handleCloseCallback={handleCloseModalCallback} sangat={userToEdit} currentUser={currentUser} onSaveCallBack={onSaveCallBack} onSaveAndAddNewCallBack={onSaveAndAddNewCallBack} />}
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={snack.open} autoHideDuration={snack.duration} onClose={closeSnack}>
                <Alert onClose={closeSnack} variant="filled" severity={snack.severity} sx={{ width: '100%' }}>
                    {snack.message}
                </Alert>
            </Snackbar>
            {showArrivingWithinThreeDays &&
                <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={showArrivingWithinThreeDays} onClose={() => { setShowArrivingWithinThreeDays(false) }}>
                    <Alert variant="filled" onClose={() => { setShowArrivingWithinThreeDays(false) }} severity="error" sx={{ marginBottom: "16px" }} >
                        <AlertTitle>Warning!</AlertTitle>
                        You're arriving really soon! Sevadars may not be able to arrange your taxi. Please confirm with local sevadar at 919501487422.
                    </Alert>
                </Snackbar>}


            <Grid container direction="row"
                justifyContent="flex-end"
                alignItems="center" spacing={2}>
                {Role !== 'ROLE_USER' &&
                    <Grid item justifyContent="flex-end" xs={2}>
                        <Button style={{ float: "right", marginRight: "10px" }} onClick={() => addNewUser()} variant="contained">Add Sangat</Button>
                    </Grid>
                }
            </Grid>
            <Paper sx={{ m: 1, p: 2 }} variant="outlined">
                <Grid container rowSpacing={1}>
                    <Grid item container xs={12} justifyContent="center">
                        <ToggleButtonGroup
                            variant="contained"
                            color="primary"
                            value={view}
                            exclusive
                            onChange={handleTableViewChange}
                            size='small'
                        >
                            <ToggleButton value={TableView.ALL}>All Sangat</ToggleButton>
                            <ToggleButton value={TableView.ARRIVAL}>Arrival Report</ToggleButton>
                            <ToggleButton value={TableView.RETURN}>Return Report</ToggleButton>
                            {isSuperUser &&
                                <ToggleButton value={TableView.TAXI}>Taxi Report</ToggleButton>
                            }
                            {isSuperUser &&
                                <ToggleButton value={TableView.BABAJI}>Baba Ji Report</ToggleButton>
                            }
                            <ToggleButton value={TableView.PENDING}>Pending User</ToggleButton>
                            {isRoomSevadar &&
                            <ToggleButton value={TableView.ROOMS}>Rooms</ToggleButton>
                            }
                        </ToggleButtonGroup>
                    </Grid>
                </Grid>

                <SangatTable flagLateEntryRow={flagLateEntryRow} selectRowCallback={handleEditUser} rowData={users} columnDefs={columnDefs} />
            </Paper>
        </div>
    )

}


export default Sangat;